<template>
  <div class="dialog-container">
    <el-button type="primary" class="import-btn" @click="dialogClick">
      <span>数据上传</span>
      <i class="el-icon-folder-add"></i>
    </el-button>
    <el-dialog
      v-drag:common
      title="数据上传"
      :visible.sync="uploadDialog.visible"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="550px"
      @close="cancelDialog()"
    >
      <el-form :rules="rule" :model="uploadDialog" ref="form">
        <el-form-item
          label="数据类型"
          label-width="80px"
          style="padding-top: 20px"
        >
          <el-radio v-if="radio === '1'" v-model="radio" label="1"
            >风机数据</el-radio
          >
          <el-radio v-if="radio === '2'" v-model="radio" label="2"
            >部件数据</el-radio
          >
        </el-form-item>
        <el-form-item label="数据文件" label-width="80px" prop="fileInfo">
          <el-upload
            class="upload"
            ref="upload"
            accept=".xls,.xlsx"
            :action="action"
            name="file"
            :data="formHeader"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="onFileSelectChange"
            :on-success="onFileUploadSuccess"
            :on-error="onFileSelectError"
          >
            <el-input
              placeholder="请选择文件"
              readonly
              style="width: 260px"
              slot="trigger"
              :value="uploadDialog.fileInfo"
              suffix-icon="el-icon-files"
            ></el-input>
            <a
              :href="downloadUrl"
              target="_blank"
              download
              class="import-button"
            >
              <el-button size="mini" type="info" round
                ><i class="el-icon-download"></i>模板下载</el-button
              >
            </a>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="厂商"
          label-width="80px"
          v-if="radio === '1'"
          prop="company"
        >
          <el-radio v-model="uploadDialog.vendor" label="0">东方电气</el-radio>
          <el-radio v-model="uploadDialog.vendor" label="1">其他厂商</el-radio>
        </el-form-item>
        <el-form-item style="margin-bottom: 0;">
          <el-col :span="24" align="right">
            <el-button @click="cancelDialog()" type="info">取消</el-button>
            <el-button
              type="primary"
              @click="submitUpload()"
              :loading="uploadDialog.loading"
              >确认</el-button
            >
          </el-col>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils';
export default {
  name: 'uploader',
  props: {
    type: String
  },
  data() {
    return {
      radio: '1',
      action: `${process.env.VUE_APP_API_HOST}/windfarm/turbineType/uploadTurbineFile`,
      downloadUrl: `${process.env.VUE_APP_TEMPLATE_HOST}/机组数据模板.xlsx`,
      uploadDialog: {
        loading: false,
        visible: false,
        fileInfo: '',
        vendor: '0'
      },
      rule: {
        fileInfo: [
          { required: true, message: '请上传文件', trigger: 'change' }
        ],
        conpany: [{ required: true, message: '请选择厂商' }]
      }
    };
  },
  computed: {
    formHeader() {
      if (this.radio === '2') {
        return {
          apiKey: getToken()
        };
      }
      return {
        vendor: this.uploadDialog.vendor,
        apiKey: getToken()
      };
    }
  },
  watch: {
    radio(val) {
      if (val === '2') {
        this.action = `${process.env.VUE_APP_API_HOST}/windfarm/turbineType/uploadUnitFile`;
        this.downloadUrl = `${process.env.VUE_APP_TEMPLATE_HOST}/部件数据模板.xlsx`;
      } else {
        this.action = `${process.env.VUE_APP_API_HOST}/windfarm/turbineType/uploadTurbineFile`;
        this.downloadUrl = `${process.env.VUE_APP_TEMPLATE_HOST}/机组数据模板.xlsx`;
      }
    }
  },
  methods: {
    dialogClick() {
      this.uploadDialog.visible = true;
      this.uploadDialog.loading = false;
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },
    onFileSelectChange(val) {
      this.uploadDialog.fileInfo = val.name;
    },
    onFileUploadSuccess(val) {
      this.uploadDialog.loading = false;
      this.uploadDialog.visible = false;
      if (this.$refs.form) {
        this.$refs.upload.clearFiles();
      }
      if (val.code === 0) {
        this.$emit('upload', true);
        this.$message({
          message: '上传成功',
          type: 'success'
        });
      } else {
        this.$emit('upload', false);
        this.$message({
          message: '上传失败',
          type: 'error'
        });
      }
    },
    onFileSelectError() {
      this.uploadDialog.visible = false;
      this.uploadDialog.loading = false;
      this.$emit('upload', false);
      this.$message({
        message: '上传文件失败',
        type: 'error'
      });
    },
    submitUpload() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.uploadDialog.loading = true;
          this.$refs.upload.submit();
        }
      });
    },
    cancelDialog() {
      this.uploadDialog.visible = false;
      this.uploadDialog.loading = false;
      this.uploadDialog = {
        ...this.uploadDialog,
        fileInfo: '',
        vendor: '0'
      };
      if (this.$refs.form) {
        this.$refs.upload.clearFiles();
        this.$refs.form.clearValidate();
      }
    }
  },
  mounted() {
    //console.log(this.type);
    if (this.type === 'unit') {
      this.radio = '2';
      return;
    }
    this.radio = '1';
  }
};
</script>

<style lang="less" scoped>
.dialog-container {
  .import-btn {
    text-align: left;
    span {
      margin-right: 8px;
    }
  }
  /deep/.el-dialog {
    .el-dialog__header {
      text-align: left;
    }
    .el-dialog__body {
      text-align: left;
      background-color: rgba(36, 45, 45, 0.8);
    }
    .import-button {
      margin-left: 20px;
    }
  }
}

/deep/.el-form-item {
  .el-form-item__label {
    color: #fff;
    text-align: right;
  }
  .el-radio {
    color: #fff;
  }
}

.file-icon {
  font-size: 24px;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  vertical-align: middle;
}
</style>
